export const _loginSuccess = "_loginSuccess";
export const _studentDataResponse = "_studentDataResponse";
export const candidateAssignedPrograms = "candidateAssignedPrograms";
export const _studentDashboardResponse = "_studentDashboardResponse";
export const _switchWhiteLabelProp = "_switchWhiteLabelProp";
export const _uploadedImageForShare = "_uploadedImageForShare";
export const _base64ProfileImage = "_base64ProfileImage";
export const _uploadToStorage = "_uploadToStorage";
export const _createNewFeed = "_createNewFeed";

// tutor journey types
export const _allProgramsDataSuccess = "_allProgramsDataSuccess";
export const _getTutorData = "_getTutorData";
export const _setProgramName = "_setProgramName";
export const _setAttendanceData = "_setAttendanceData";
export const _postAttendance = "_postAttendance";

// adding education mama leads data
export const _emLeadsData = "_emLeadsData";
export const _ownLead = "_ownLead";
export const _withdrawLead = "_withdrawLead";
export const _changeFaqData = "_changeFaqData";
export const _loadMoreData = "_loadMoreData";

// Planner Action Types
export const _getAllChaptersOfProgram = "_getAllChaptersOfProgram";
export const _getTopicsFortheChapters = "_getTopicsFortheChapters";
export const _addTopic = "_addTopic";
export const _addPlanner = "_addPlanner";
export const _getPlanners = "_getPlanners";

//Start Class Actions
export const _getClassStartTime = "_getClassStartTime";
